<template>
  <div>
    <el-container>
      <el-header class="main-panel-header">
        <div>
          <el-menu :default-active="'daily-report'" mode="horizontal" slot="menu" @select="changePanel">
            <el-menu-item index="user-name">
              <el-dropdown @command="handleCommand" trigger="click">
                <el-button type="text"><span class="el-icon-user-solid"></span>{{ user.name }}，您好！</el-button>
                <el-dropdown-menu>
                  <el-dropdown-item command="change-pwd"><span class="el-icon-setting"></span>修改密码</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-menu-item>
            <el-menu-item class="sm-hidden" index="daily-report">
              <span class="el-icon-s-management"></span><span class="sm-hidden">日报管理</span>
            </el-menu-item>
            <el-menu-item class="sm-hidden" index="do-search">
              <span class="el-icon-search"></span><span class="sm-hidden">实时查询</span>
            </el-menu-item>
            <el-menu-item class="sm-hidden" index="concerned">
              <span class="el-icon-timer"></span><span class="sm-hidden">关注项管理</span>
            </el-menu-item>
            <el-menu-item v-if="isAdmin" class="sm-hidden" index="user-management">
              <span class="el-icon-user"></span><span class="sm-hidden">用户管理</span>
            </el-menu-item>
            <el-menu-item style="float: right" index="logout">
              <span class="el-icon-upload2"></span><span>登出</span>
            </el-menu-item>
          </el-menu>
        </div>
      </el-header>
      <el-main class="main-panel">
        <div style="margin: 15px 0">
          <router-view></router-view>
        </div>
      </el-main>
      <footer class="sm-show">
        <div class="footer-menu">
          <span class="menu-item" @click="gotoDaily" ref="footer-item-1" :class="isActive('footer-item-1')"><span
              class="el-icon-s-management"></span></span>
          <span class="menu-item" @click="goToSearch" ref="footer-item-2" :class="isActive('footer-item-2')"><span
              class="el-icon-search"></span></span>
          <span class="menu-item" @click="gotoConcerned" ref="footer-item-3" :class="isActive('footer-item-3')"><span
              class="el-icon-timer"></span></span>
          <span class="menu-item" ref="footer-item-3"><span class="el-icon-upload2"></span></span>
        </div>
      </footer>
    </el-container>
    <el-dialog :visible.sync="showPwdForm" show-close custom-class="pwd-modify-panel">
      <user-pwd-form :model="user" @success="hidePwdForm" @cancel="hidePwdForm"></user-pwd-form>
    </el-dialog>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex"
import DailyReport from "@/models/DailyReport";
import UserPwdForm from "@/components/user/UserPwdForm";

export default {
  name: "MainPanel",
  components: {
    UserPwdForm
  },
  data() {
    return {
      loading: false,
      report: new DailyReport(),
      showPwdForm: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'currentUser',
      isAdmin: 'isAdmin'
    })
  },
  mounted() {
    this.gotoDaily()
  },
  methods: {
    ...mapActions({
      doLogout: 'logout'
    }),
    gotoDaily() {
      if (this.$route.path.indexOf("/main/daily") < 0) {
        this.$router.push('/main/daily')
      }
    },
    goToSearch() {
      if (this.$route.path.indexOf("/main/search") < 0) {
        this.$router.push('/main/search')
      }
    },
    gotoConcerned() {
      if (this.$route.path.indexOf("/main/concerned") < 0) {
        this.$router.push('/main/concerned')
      }
    },
    gotoUserPanel() {
      if (this.$route.path.indexOf("/main/user") < 0) {
        this.$router.push('/main/user')
      }
    },
    logout() {
      this.$confirm("您确定要退出系统吗？", {customClass: 'small-dialog'}).then(() => {
        this.doLogout()
        this.$router.push('/login')
      })
    },
    changePanel(name) {
      switch (name) {
        case 'user-management':
          this.gotoUserPanel();
          break;
        case 'user-name':
          break
        case 'concerned':
          this.gotoConcerned()
          break
        case 'do-search':
          this.goToSearch()
          break
        case 'logout':
          this.logout()
          break
        case 'daily-report':
        default:
          this.gotoDaily()
      }
    },
    handleCommand(m) {
      if (m === 'change-pwd') {
        this.showPwdForm = true
      }
    },
    hidePwdForm() {
      this.showPwdForm = false
    },
    isActive(itemName) {
      switch (itemName) {
        case 'footer-item-1':
          if (this.$route.path === '/main/daily') {
            return 'active'
          }
          break
        case 'footer-item-2':
          if (this.$route.path === '/main/search') {
            return 'active'
          }
          break
        case 'footer-item-3':
          if (this.$route.path === '/main/concerned') {
            return 'active'
          }
          break
      }
      return ''
    }
  }
}
</script>

<style scoped>
.main-panel {
  min-height: 500px;
  margin-top: 51px;
}

.main-panel-header {
  position: fixed;
  left: 0;
  top: 0;
  display: block;
  width: 100%;
  height: 50px;
  background-color: white;
  opacity: 1;
  z-index: 999;
}

footer {
  border-top: 1px solid #eee;
  position: fixed;
  top: calc(100% - 50px);
  left: 0;
  height: 50px;
  /*text-align: center;*/
  vertical-align: middle;
  width: 100%;
}

.footer-menu {
  margin: auto;
  vertical-align: middle;
  width: 100%;
}

.menu-item.active {
  background-color: #eee;
}

.menu-item {
  font-size: 20px;
  padding-top: 12px;
  width: 33%;
  height: 40px;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  color: #555;
  border-right: 1px solid #ddd;
  text-align: center;
  background-color: #fff;
}

.menu-item:hover {
  color: #000;
}

</style>
